import React from "react";
import { Button } from "../../../common/u1/Button";
import { PanelCard } from "./PanelCard";
import { NoticeBox } from "./NoticeBox";
import { VerificationTimeline } from "./VerificationTimeline";
import { BenefitItem } from "./BenefitItem";
import { UNLOCK_BENEFITS } from "../../Dashboard/membership/membershipContent";

/* The right-hand panel: verification, which a member can add for free. */
export const REVIEW_STEPS = [
  { state: "done", label: "Request submitted", sub: "Just now" },
  {
    state: "current",
    label: "Under review by TREVEX",
    sub: "In progress — the team may ask for documents",
  },
  { state: "todo", label: "Verified badge added", sub: "Pending" },
];

export const VERIFIED_STEPS = [
  { state: "done", label: "Request submitted", sub: "Done" },
  { state: "done", label: "Reviewed by TREVEX", sub: "Approved" },
  { state: "done", label: "Verified badge added", sub: "Live on your public profile" },
];

export const VerificationPanel = ({
  state = "idle",
  benefits = UNLOCK_BENEFITS,
  isRequesting = false,
  onRequest = () => {},
  onCancel = () => {},
  onViewProfile = () => {},
  className = "",
}) => (
  <PanelCard
    accent="green"
    eyebrow="Free perk"
    title="Add verification"
    intro={
      state === "verified"
        ? "Your verification is complete — the green Verified badge is live on your public profile."
        : "A free, optional benefit — never a purchase. Request the green Verified badge whenever you're ready."
    }
    className={className}
  >
    {state === "idle" && (
      <>
        <div className="mb-[22px] flex flex-col gap-4">
          {benefits.map((b) => (
            <BenefitItem key={b.title} title={b.title} body={b.body} tone="unlock" />
          ))}
        </div>
        {/* Pinned to the foot of the panel: both panels are now the same
            height, so without this the action would float wherever this
            panel's own text happened to end. */}
        <div className="mt-auto">
        <Button
          variant="coralSolid"
          onClick={onRequest}
          disabled={isRequesting}
          className="h-auto w-full rounded-xl py-3.5 text-[15px] font-bold"
        >
          {isRequesting ? "Requesting…" : "Request verification"}
        </Button>
        <p className="mt-[11px] mb-0 text-center text-[12px] text-[var(--muted-2)] font-sans">
          Sends a request to the TREVEX team — no payment, no commitment.
        </p>
        </div>
      </>
    )}

    {state === "review" && (
      <>
        <NoticeBox tone="pending" title="Your request has been sent" className="mb-5">
          The TREVEX team will review the documents for your profile data and get back to you.
        </NoticeBox>
        <VerificationTimeline steps={REVIEW_STEPS} className="mb-5" />
        <Button variant="outline" onClick={onCancel} className="h-auto w-full rounded-xl py-[11px] text-[13.5px]">
          Cancel request
        </Button>
      </>
    )}

    {state === "verified" && (
      <>
        <NoticeBox tone="done" title="Your business is verified" className="mb-5">
          Every data point on your profile has been checked by TREVEX. Your Verified badge is live.
        </NoticeBox>
        <VerificationTimeline steps={VERIFIED_STEPS} className="mb-5" />
        <Button variant="coral" onClick={onViewProfile} className="h-auto w-full rounded-xl py-3 text-[14px]">
          View public profile
        </Button>
      </>
    )}
  </PanelCard>
);

export default VerificationPanel;
